import { createContext, useState, useEffect, useRef } from "react";
import UtilsAlgo from '@utils/utilsAlgo';
export const BatchImagesContext = createContext()

export const BatchImagesContextProvider = (props) => {
    const isMounted = useRef(true)
    useEffect(() => {
        return () => isMounted.current = false
    }, [])

    const [fileList, setFileList] = useState([])
    const [referenceResList, setReferenceResList] = useState([])
    const [projectType, setProjectType] = useState('')
    const [selectSkuId, setSelectSkuId] = useState('')
    const [uploadImgToSkuId, setUploadImgToSkuId] = useState('')
    const [isBatchAppendSmartPage, setIsBatchAppendSmartPage] = useState(false) // 是否是批量设置智能详情页的颜色、模板、类目
    const getSemanticSimTryonMaskId = UtilsAlgo.getSemanticSimTryonMaskId
    const getMultiSemanticOutput = id => UtilsAlgo.getMultiSemanticOutput(id, () => !isMounted.current)

    return (
        <BatchImagesContext.Provider value={{
            fileList, setFileList,
            projectType, setProjectType,
            referenceResList, setReferenceResList,
            selectSkuId, setSelectSkuId,
            getSemanticSimTryonMaskId,
            uploadImgToSkuId, setUploadImgToSkuId,
            isBatchAppendSmartPage, setIsBatchAppendSmartPage,
            getMultiSemanticOutput
        }}>
            {props.children}
        </BatchImagesContext.Provider>
    );
}
